import { SubtitlesConfig } from '@/scenarios/legacy-player/components/Player/types';

import { useLeftJoin } from '../../hooks/useLeftJoinAudioTracks';
import { Subtitles } from '../../Tracks.types';

export const useLeftJoinSubtitles: (
    subtitles: readonly Subtitles[],
    subtitlesMeta: SubtitlesConfig
) => Map<string, Subtitles> = (subtitles, subtitlesMeta) =>
    useLeftJoin(
        { data: subtitles, getKey: (track) => track.lang },
        { data: subtitlesMeta, getKey: (track) => track.language }
    );
